export default {
  folder: "dashing",
  interior: {
    points: [
      [2200, -500, -2200], // External Environment Display
      [2200, -300, 0], // 15.6 Inch Infotainment
      [2000, -1800, -200], // Wireless Charging
      [1900, -900, -2200], // Surround Hi-Fi 8 speakers
      [2000, -600, -1700], // Cruise Control
      [1000, 2000, 0], // Panoramic Sunroof
    ],
  },
  exterior: {
    hotspots: {
      h1: {
        // LED Day Time Running Lights and Head Lights
        popup: 1,
        point: [
          [45, 50], // f1
          [35, 49], // f2
          [27, 49], // f3
          [21, 49], // f4
          [17, 48], // f5
          [14, 46], // f6
          null, // f7
          null, // f8
          null, // f9
          null, // f10
          null, // f11
          null, // f12
          null, // f13
          null, // f14
          null, // f15
          null, // f16
          null, // f17
          null, // f18
          null, // f19
          null, // f20
          null, // f21
          null, // f22
          null, // f23
          null, // f24
          null, // f25
          null, // f26
          [81, 48], // f27
          [77, 50], // f28
          [72, 50], // f29
          [65, 51], // f30
          [58, 51], // f31
          [51, 51], // f32
          [43, 51], // f33
          [36, 50], // f34
          [55, 51], // f35
          [48, 50], // f36
        ],
      },
      h2: {
        // Checkered LED Tail Lights
        popup: 2,
        point: [
          null, // f1
          null, // f2
          null, // f3
          null, // f4
          null, // f5
          null, // f6
          null, // f7
          null, // f8
          [74, 37], // f9
          [69, 38], // f10
          [64, 39], // f11
          [59, 39], // f12
          [53, 39], // f13
          [47, 39], // f14
          [41, 39], // f15
          [36, 39], // f16
          [56, 39], // f17
          [50, 40], // f18
          [44, 40], // f19
          [38, 39], // f20
          [33, 39], // f21
          [28, 39], // f22
          [24, 38], // f23
          [20, 37], // f24
          [18, 36], // f25
          [17, 35], // f26
          null, // f27
          null, // f28
          null, // f29
          null, // f30
          null, // f31
          null, // f32
          null, // f33
          null, // f34
          null, // f35
          null, // f36
        ],
      },
      h3: {
        // High Performance 1.6T Engine
        popup: 3,
        point: [
          [34, 38], // f1
          [28, 38], // f2
          [24, 36], // f3
          [27, 35], // f4
          [24, 34], // f5
          null, // f6
          null, // f7
          null, // f8
          null, // f9
          null, // f10
          null, // f11
          null, // f12
          null, // f13
          null, // f14
          null, // f15
          null, // f16
          null, // f17
          null, // f18
          null, // f19
          null, // f20
          null, // f21
          null, // f22
          null, // f23
          null, // f24
          null, // f25
          null, // f26
          [71, 36], // f27
          [71, 36], // f28
          [70, 36], // f29
          [69, 36], // f30
          [65, 36], // f31
          [60, 36], // f32
          [55, 36], // f33
          [49, 36], // f34
          [43, 36], // f35
          [37, 36], // f36
        ],
      },
      h4: {
        // Multi-dimensional Sporty Body
        popup: 4,
        point: [
          [55, 40], // f1
          [50, 40], // f2
          [43, 41], // f3
          [38, 41], // f4
          [36, 41], // f5
          [36, 41], // f6
          [34, 41], // f7
          [29, 40], // f8
          [29, 40], // f9
          [29, 40], // f10
          [29, 40], // f11
          [33, 41], // f12
          [35, 40], // f13
          [37, 40], // f14
          null, // f15
          null, // f16
          null, // f17
          [65, 43], // f18
          [65, 43], // f19
          [65, 42], // f20
          [65, 42], // f21
          [65, 42], // f22
          [65, 42], // f23
          [65, 42], // f24
          [65, 42], // f25
          [65, 42], // f26
          [61, 42], // f27
          [57, 42], // f28
          [54, 43], // f29
          [50, 42], // f30
          [47, 41], // f31
          [41, 41], // f32
          null, // f33
          null, // f34
          null, // f35
          [59, 40], // f36
        ],
      },
      h5: {
        // Hidden Door Handle with Smart Sensor
        popup: 5,
        point: [
          [66, 36], // f1
          [63, 36], // f2
          [60, 37], // f3
          [56, 37], // f4
          [52, 37], // f5
          [48, 38], // f6
          [45, 38], // f7
          [42, 38], // f8
          [41, 38], // f9
          [40, 38], // f10
          [49, 39], // f11
          [47, 39], // f12
          [43, 39], // f13
          null, // f14
          null, // f15
          null, // f16
          null, // f17
          [60, 39], // f18
          [56, 40], // f19
          [52, 40], // f20
          [48, 40], // f21
          [44, 39], // f22
          [39, 39], // f23
          [36, 38], // f24
          [51, 38], // f25
          [48, 38], // f26
          [45, 38], // f27
          [43, 37], // f28
          [42, 37], // f29
          [40, 37], // f30
          [39, 36], // f31
          null, // f32
          null, // f33
          null, // f34
          [68, 36], // f35
          [67, 36], // f36
        ],
      },
      h6: {
        // 20-inch Sports Alloy Wheel
        popup: 6,
        point: [
          [54, 63], // f1
          [47, 62], // f2
          [40, 62], // f3
          [34, 62], // f4
          [30, 60], // f5
          [26, 60], // f6
          [24, 59], // f7
          [64, 60], // f8
          [61, 61], // f9
          [58, 61], // f10
          [53, 63], // f11
          [49, 63], // f12
          [46, 62], // f13
          null, // f14
          null, // f15
          null, // f16
          null, // f17
          [58, 63], // f18
          [54, 63], // f19
          [49, 63], // f20
          [44, 63], // f21
          [39, 63], // f22
          [36, 62], // f23
          [32, 61], // f24
          [29, 60], // f25
          [27, 58], // f26
          [68, 62], // f27
          [64, 62], // f28
          [60, 63], // f29
          [55, 63], // f30
          [50, 62], // f31
          null, // f32
          null, // f33
          null, // f34
          [63, 63], // f35
          [57, 63], // f36
        ],
      },
    },
  },
};
